import Main from 'layouts/Main';
import { WorkshopSchedule } from './components';

const Workshop = () => {
    return (
        <Main>
            <WorkshopSchedule />
        </Main>
    );
};

export default Workshop;
